<div
  class="component-container flex flex-col w-fulls gap-[2rem] break-all">
  <div class="component-heading align-middle text-center">
    Email Preview
  </div>
  <div *ngIf="manualEmail" class="note">
    Copy this text to send via your organization’s email client.
    <ng-container *ngIf="!fromManageUsers">
      <br>
      <strong>Note:</strong> Invitation links are unique to each user.
      A copy of this invite is also available via the vertical ellipsis to the
      far right of each user record in the Manage Users section.
    </ng-container>
  </div>
  <div class="email-container w-full flex flex-col">
    <div class="email-body"
         innerHTML="{{currentEmail?.html}}"
    >
    </div>
  </div>
  <div
    *ngIf="!fromManageUsers"
    class="action-panel flex flex-row justify-center items-center w-full gap-[2rem] text-[1.8rem]">

    <app-icon
      (click)="config.length === 1 ? '':onPreviousClick()"
      [class.disabled]="config.length === 1"
      [svgIcon]="config.length === 1 ? 'dropdown-disabled' :'dropdown'"
      class="previous"
    ></app-icon>

    <div class="counter ">
      {{ currentIndex + 1 }}/{{ config.length }}
    </div>

    <app-icon
      (click)="config.length === 1 ? '':onNextClick()"
      [class.disabled]="config.length === 1"
      [svgIcon]="config.length === 1 ? 'dropdown-disabled' :'dropdown'"
      class="next"
    ></app-icon>
  </div>
</div>
